@if (isValidBlog()) {
	<div class="product-blog-item">
		<div class="product-blog-item__wrapper">
			@if (blogItem?.imageItemUrl) {
				<div class="product-blog-item__image">
					<img [alt]="blogItem?.title" [src]="getCmsUrl(blogItem?.imageItemUrl)" />
				</div>
			}

			<div class="product-blog-item__content">
				@if (hasGrowerName()) {
					<h1 i18n="@@product.detail.blog.grower.title">
						About {{ blogItem?.growerName }}
					</h1>
				} @else {
					<h1>{{ blogItem?.title }}</h1>
				}

				@if (blogItem?.description) {
					<p>{{ blogItem?.description }}</p>
				}

				@if (isNovifloraBlog()) {
					<a [href]="getCmsUrl(blogItem?.blogUrl)"
					   class="button button--secondary"
					   i18n="@@product.detail.blog.read.more"
					   target="_blank">
						Read more >
					</a>
				} @else {
					<a [routerLink]="['/blogs/detail', { blogId: blogItem?.blogId }]"
					   class="button button--secondary"
					   i18n="@@product.detail.blog.read.more">
						Read more >
					</a>
				}
			</div>
		</div>
	</div>
}
